<div class="login-wrapper">
  <div class="login-container">
    <form (ngSubmit)="onSubmit()" class="form" [formGroup]="form">
      <div class="form-header">
        <h1>Esqueceu a senha?</h1>
        <span>Digite seu e-mail para recuperar a senha.</span>
      </div>
      <div class="form-group">
        <app-input
          label="Email"
          name="EMAIL"
          formControlName="EMAIL"
          placeholder="exemplo@email.com.br"></app-input>
        <app-botao
          class="button"
          type="primario"
          width="100%"
          [text]="this.title"></app-botao>

        <app-botao
          class="button"
          type="secundario"
          width="100%"
          text="Voltar"
          (click)="onBack()"></app-botao>
      </div>
    </form>
  </div>
  <div class="image-container">
    <img class="image" [class.image-wordmark]="brand.isMosten" [src]="brand.logoLogin" alt="Logo" />
  </div>
</div>
<app-loader [isLoading]="isLoading"></app-loader>
